import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'data' })
export class TransformaObjetoEmListaPipe implements PipeTransform {
  
  transform(value: any ): any {
    
    let objetoTransformado = value.map((obj)=>obj.placa).join(';')        

    return objetoTransformado;
  }
}


// WEBPACK FOOTER //
// ./src/app/pipes/transformaObjetoEmLista.pipe.ts